import React from 'react';
import styled from '@emotion/styled';
import { ThumbsUp, ThumbsDown, Minus } from 'lucide-react';

/**
 * StanceItem — one statement, three positions: agree, unsure, disagree. The
 * Kysely's sharper claims and the change meter's blind re-ask are this piece;
 * Peilaus draws its own, older stance row. Pure: value in, onChange out.
 */
const Row = styled.div`
  display: flex; flex-direction: column; gap: 0.6rem; padding: 0.9rem 1rem; border-radius: 10px;
  background: #141821; border: 1px solid #232a36; color: #e8e8ef; line-height: 1.45;
`;
const Buttons = styled.div`display: flex; gap: 0.4rem; flex-wrap: wrap;`;
const B = styled.button`
  all: unset; cursor: pointer; display: inline-flex; align-items: center; gap: 0.4rem;
  padding: 0.5rem 0.85rem; border-radius: 999px; font-size: 0.88rem; font-weight: 600;
  border: 1px solid ${(p) => (p.$on ? p.$c : '#2f3745')}; color: ${(p) => (p.$on ? p.$c : '#9aa4b2')};
  background: ${(p) => (p.$on ? p.$bg : 'transparent')};
  &:hover, &:focus-visible { border-color: ${(p) => p.$c}; color: ${(p) => p.$c}; }
  &:disabled { cursor: default; opacity: 0.7; }
`;

export const STANCES = [
  { id: 'agree', color: '#6fd3c8', bg: 'rgba(111, 211, 200, 0.14)', Icon: ThumbsUp },
  { id: 'unsure', color: '#c9cbd6', bg: 'rgba(201, 203, 214, 0.12)', Icon: Minus },
  { id: 'disagree', color: '#FF8A85', bg: 'rgba(239, 83, 80, 0.14)', Icon: ThumbsDown },
];

/** @param {{ text: string, value: 'agree'|'unsure'|'disagree'|null, onChange, labels: {agree,unsure,disagree}, disabled }} */
export default function StanceItem({ text, value = null, onChange, labels, disabled = false }) {
  return (
    <Row role="radiogroup" aria-label={text}>
      <div>{text}</div>
      <Buttons>
        {STANCES.map(({ id, color, bg, Icon }) => (
          <B key={id} type="button" role="radio" aria-checked={value === id} $on={value === id} $c={color} $bg={bg}
             disabled={disabled} onClick={() => !disabled && onChange?.(value === id ? null : id)}>
            <Icon size={14} /> {labels?.[id] || id}
          </B>
        ))}
      </Buttons>
    </Row>
  );
}
